import { render, staticRenderFns } from "./APIQueue.vue?vue&type=template&id=f5e46964&"
import script from "./APIQueue.vue?vue&type=script&lang=js&"
export * from "./APIQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports